// Vendor Libs
import React from 'react';
import { useSnackbar } from 'notistack'; // Material UI

import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
export var useToast = function useToast() {
  var _useSnackbar = useSnackbar(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar,
      closeSnackbar = _useSnackbar.closeSnackbar;

  var createToast = function createToast(message, _temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$anchorOrigin = _ref.anchorOrigin,
        anchorOrigin = _ref$anchorOrigin === void 0 ? {
      horizontal: 'center',
      vertical: 'top'
    } : _ref$anchorOrigin,
        _onClose = _ref.onClose,
        _ref$persist = _ref.persist,
        persist = _ref$persist === void 0 ? false : _ref$persist,
        _ref$variant = _ref.variant,
        variant = _ref$variant === void 0 ? 'success' : _ref$variant;

    enqueueSnackbar(message, {
      action: function action(key) {
        return React.createElement(IconButton, {
          color: "inherit",
          key: "close",
          onClick: function onClick() {
            closeSnackbar(key);
          }
        }, React.createElement(CloseIcon, null));
      },
      anchorOrigin: anchorOrigin,
      onClose: function onClose(event, reason) {
        if (typeof _onClose === 'function') {
          _onClose(event, reason);
        }
      },
      persist: persist,
      variant: variant
    });
  };

  return {
    createToast: createToast
  };
};